/** Words of "Chụp bằng camera" (plan v4 web tăng cường mục 3); kept here, next to the dialog, not in messages.ts. */
import type { CheckCode } from "./assess";
import type { CameraErrorCode } from "./camera";

export const CAMERA = {
  open: "Chụp bằng camera",
  title: "Chụp bằng camera",
  opening: "Đang mở camera…",
  dialogFailed: "Không tải được hộp chụp ảnh. Kiểm tra mạng rồi thử lại.",
  guideSpec: (label: string) => `Khung theo quy cách ${label}: đặt cả đầu vào hình oval.`,
  guideFree: "Đặt khuôn mặt vào hình oval.",
  checking: "Đang tải phần kiểm tra khuôn mặt…",
  noChecks: "Trình duyệt này không chạy được phần kiểm tra khuôn mặt — vẫn chụp được, hãy tự căn mặt theo khung.",
  privacy: "Hình từ camera chỉ được xử lý ngay trên máy bạn, không gửi đi đâu cho tới khi bạn bấm “Dùng ảnh này”.",
  camera: "Camera",
  cameraN: (n: number) => `Camera ${n}`,
  countdown: "Tự chụp sau 3 giây khi đạt",
  shoot: "Chụp ảnh",
  use: "Dùng ảnh này",
  retake: "Chụp lại",
  retry: "Thử lại",
  close: "Đóng",
  shotAlt: "Ảnh vừa chụp",
  shotNote: "Đây là ảnh thật (không lật như khi xem trước).",
  captureFailed: "Không chụp được ảnh. Bấm Chụp ảnh lần nữa.",
  hints: {
    no_face: "Đưa khuôn mặt vào khung oval",
    many_faces: "Chỉ để một người trong khung",
    off_centre: "Đưa mặt vào giữa khung",
    too_far: "Lại gần hơn",
    too_close: "Lùi ra một chút",
    roll: "Giữ đầu thẳng, không nghiêng",
    yaw: "Nhìn thẳng vào camera",
    pitch_up: "Hạ cằm xuống một chút",
    pitch_down: "Ngẩng đầu lên một chút",
    dark: "Thiếu sáng — tìm chỗ sáng hơn",
    bright: "Mặt bị chói — tránh đèn chiếu thẳng vào mặt",
    uneven_left: "Mặt bên trái tối hơn — quay về phía nguồn sáng",
    uneven_right: "Mặt bên phải tối hơn — quay về phía nguồn sáng",
    ok: "Tốt rồi — giữ nguyên và bấm Chụp ảnh",
  } satisfies Record<CheckCode, string>,
  errors: {
    insecure: "Camera chỉ dùng được khi trang mở bằng địa chỉ https:// (hoặc localhost). Hãy mở lại trang bằng https://, hoặc chọn ảnh có sẵn.",
    unsupported: "Trình duyệt này không cho trang web dùng camera. Hãy dùng Chrome, Safari, Edge hoặc Firefox bản mới, hoặc chọn ảnh có sẵn.",
    denied: "Trang chưa được phép dùng camera. Bấm biểu tượng camera / ổ khoá trên thanh địa chỉ, chọn Cho phép, rồi bấm Thử lại.",
    not_found: "Không tìm thấy camera nào trên thiết bị này. Cắm camera rồi bấm Thử lại, hoặc chọn ảnh có sẵn.",
    busy: "Camera đang được ứng dụng khác dùng (Zalo, Zoom, Meet…). Tắt ứng dụng đó rồi bấm Thử lại.",
    failed: "Không mở được camera. Bấm Thử lại, hoặc chọn ảnh có sẵn.",
  } satisfies Record<CameraErrorCode, string>,
};
